<cipo-dialog-header [title]="title" fullScreen="never" [customCloseMode]="true" (closeClick)="tryClose()" />

<mat-dialog-content>
    <div class="cipo--flex--column cipo--gap--lg p-y-sm" data-testid="permissions-dialog">
        <div class="cipo--flex--row cipo--flex--wrap cipo--justify--between cipo--align--center cipo--gap--lg">
            <span class="cipo--text-weight--medium">{{ subtitle }}</span>
            <mat-slide-toggle
                data-testid="permissions-dialog-toggle-all"
                [checked]="allSelected()"
                [disabled]="!canUpdate || !permissions().length"
                (change)="selectAll($event.checked)">
                {{ "roles.permissions.selectAll" | translate }}
            </mat-slide-toggle>
        </div>

        @for (permission of permissions(); track permission.id) {
            <div
                class="cipo--flex--row cipo--flex--wrap cipo--justify--between cipo--align--center cipo--gap--lg p-y-sm cipo--border-bottom--lite"
                data-testid="permissions-dialog-permission"
                [class.cipo-bg--primary-50]="permission.isUsed">
                <div class="cipo--flex--row cipo--align--start cipo--gap--sm cipo--flex--1 cipo--min-width--200">
                    <mat-checkbox
                        data-testid="permissions-dialog-permission-checkbox"
                        [checked]="permission.isUsed"
                        [disabled]="permission.isDefault || !canUpdate"
                        [attr.aria-labelledby]="'permission-label-' + permission.id"
                        (change)="togglePermission(permission)" />
                    <div class="cipo--flex--column">
                        <span
                            class="cipo--text-weight--medium"
                            data-testid="permissions-dialog-permission-name"
                            [id]="'permission-label-' + permission.id">
                            {{ permission.name }}
                        </span>
                        @if (permission.description) {
                            <span class="mat-body-2 cipo-text--secondary">{{ permission.description }}</span>
                        }
                    </div>
                </div>

                <div class="cipo--flex--row cipo--align--center cipo--flex--1 cipo--min-width--200">
                    @if (permission.filters?.length > 1) {
                        <mat-button-toggle-group
                            [value]="permission.filterId"
                            [disabled]="!permission.isUsed || !canUpdate"
                            [attr.aria-labelledby]="'permission-label-' + permission.id"
                            (change)="setFilterId(permission, $event.value)">
                            @for (filter of permission.filters; track filter.key) {
                                <mat-button-toggle [value]="filter.key" [title]="filter.description">
                                    {{ filter.value }}
                                </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    } @else if (permission.filters?.length === 1) {
                        <div class="cipo--flex--column">
                            <span>{{ permission.filters[0].value }}</span>
                            @if (permission.filters[0].description) {
                                <span class="mat-body-2 cipo-text--secondary">
                                    {{ permission.filters[0].description }}
                                </span>
                            }
                        </div>
                    }
                </div>
            </div>
        } @empty {
            <span class="cipo-text--secondary">{{ "roles.permissions.none" | translate }}</span>
        }
    </div>
</mat-dialog-content>

@if (canUpdate) {
    <mat-dialog-actions align="end" [class.cipo-bg--warn-400]="warningContext()">
        @if (warningContext()) {
            <span class="m-r-sm">{{ "general.discardMessage" | translate }}</span>
            <button mat-stroked-button (click)="dismissWarning()">{{ "actions.cancel" | translate }}</button>
            <button
                mat-stroked-button
                color="warn"
                data-testid="permissions-dialog-action-discard"
                (click)="discardAndClose()">
                {{ "actions.discard" | translate }}
            </button>
            <button mat-flat-button color="primary" data-testid="permissions-dialog-action-apply" (click)="apply()">
                {{ "actions.update" | translate }}
            </button>
        } @else {
            <button mat-button data-testid="permissions-dialog-action-cancel" (click)="tryClose()">
                {{ "general.cancel" | translate }}
            </button>
            <button mat-flat-button color="primary" data-testid="permissions-dialog-action-apply" (click)="apply()">
                {{ "actions.update" | translate }}
            </button>
        }
    </mat-dialog-actions>
}
